import Pesquisar from "../../components/pesquisar/pesquisar";


function Consulta() {

    return <Pesquisar/>
    

}

export default Consulta;